module.exports = __webpack_public_path__ + "static/img/wiki_logo.caa201c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Meeting/wiki_logo.jpeg
// module id = 2Y2n
// module chunks = 4